<template>
  <div class="bj-warp" >
    <div class="banner-box" :style="style"></div>
    <div class="content-box">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "loginLayout",
  data() {
    return {
      style: {
        background: `url(${require("assets/image/login-bg.png")}) no-repeat top left`,
        backgroundSize: "cover",
      },
      menuList: [
        {
          name: "域名注册",
          path: "/index",
          target: "self",
        },
        {
          name: "关于我们",
          path: "http://www.domainfuture.cn/about_complex.aspx?nid=1",
          target: "blank",
        },
        {
          name: "联系我们",
          path: "http://www.domainfuture.cn/contact_complex.aspx?nid=7",
          target: "blank",
        }
      ],
    };
  },
};
</script>
<style lang="less" scoped>
.bj-warp {
  display: flex;
  justify-content: space-between;
  .banner-box{
    flex: 1;
    background-size: cover;
    background-position: top center;
    background-repeat: no-repeat;
    background-color:aqua;
    height: 100vh;
    font-size: 0;
  }
  .content-box{
    flex: 0 0 500px;
    background-color: #fff;
  }
}
</style>
